import React from 'react';
import T from 'i18n-react';
import InfoRow from './InfoRow';
import useIsMounted from 'ismounted';
import PhoneDialog from './Phone/PhoneDialog';
import Typography from '@material-ui/core/Typography';

const PhoneNumberField = ({
  phoneNumber,
  phoneCountryCode,
  phoneVerifiedAt,
  requirePrompt = false,
}) => {
  const dialogRef = React.useRef();

  const isMounted = useIsMounted();
  const [state, setState] = React.useState({
    phoneNumber,
    phoneCountryCode,
    phoneVerifiedAt,
  });

  const phoneText = T.translate('user.phoneNumber');

  let statusText;
  if (state.phoneNumber) {
    if (state.phoneVerifiedAt) {
      statusText = T.translate('parentheses', {
        text: T.translate('user.phoneVerified'),
      });
    } else {
      statusText = (
        <Typography component="span" color="error">
          {T.translate('parentheses', {
            text: T.translate('user.phoneUnverified'),
          })}
        </Typography>
      );
    }
  }

  return (
    <>
      <InfoRow
        title={phoneText}
        loaded
        isNewChecker={() => !state.phoneNumber}
        text={
          <span>
            {state.phoneNumber}
            {statusText}
          </span>
        }
        newText={T.translate('registerX', { x: phoneText })}
        onButtonClick={() => dialogRef.current?.handleOpen?.()}
        prompt={requirePrompt ? !state.phoneVerifiedAt : true}
      />
      <PhoneDialog
        countryCode={phoneCountryCode}
        phoneNumber={phoneNumber}
        verifiedAt={phoneVerifiedAt}
        onSuccess={({ phoneNumber, phoneCountryCode, phoneVerifiedAt }) => {
          isMounted.current &&
            setState({ phoneNumber, phoneCountryCode, phoneVerifiedAt });
        }}
        ref={dialogRef}
      />
    </>
  );
};

export default PhoneNumberField;
